import type { ReactNode } from 'react';

const URL_OR_EMAIL = /(https?:\/\/[^\s]+)|([\w.+-]+@[\w-]+\.[\w.-]+)/g;
const TRAILING_PUNCTUATION = /[.,;:!?)\]}'"’”]+$/;

export function linkifyText(text: string): ReactNode[] {
  const nodes: ReactNode[] = [];
  let lastIndex = 0;
  let key = 0;
  let match: RegExpExecArray | null;

  URL_OR_EMAIL.lastIndex = 0;
  while ((match = URL_OR_EMAIL.exec(text)) !== null) {
    const [full, url, email] = match;
    const start = match.index;

    if (start > lastIndex) {
      nodes.push(text.slice(lastIndex, start));
    }

    const trailingMatch = full.match(TRAILING_PUNCTUATION);
    const trailing = trailingMatch ? trailingMatch[0] : '';
    const clean = trailing ? full.slice(0, full.length - trailing.length) : full;

    if (url) {
      nodes.push(
        <a
          key={key++}
          href={clean}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary underline underline-offset-4"
        >
          {clean}
        </a>,
      );
    } else if (email) {
      nodes.push(
        <a key={key++} href={`mailto:${clean}`} className="text-primary underline underline-offset-4">
          {clean}
        </a>,
      );
    }
    if (trailing) {
      nodes.push(trailing);
    }

    lastIndex = start + full.length;
  }

  if (lastIndex < text.length) {
    nodes.push(text.slice(lastIndex));
  }

  return nodes;
}
